var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8607 12.9679C33.1402 12.2475 32.78 11.3469 32.78 10.4464C32.78 6.48396 29.538 3.24198 25.5756 3.24198C24.6751 3.24198 23.7745 2.88176 23.0541 2.16132C20.1723 -0.72044 15.6696 -0.72044 12.7878 2.16132C12.2475 2.88176 11.3469 3.24198 10.4464 3.24198C6.48396 3.24198 3.24198 6.48396 3.24198 10.4464C3.24198 11.3469 2.88176 12.2475 2.16132 12.9679C-0.72044 15.8497 -0.72044 20.3524 2.16132 23.2342C2.88176 23.9546 3.24198 24.8552 3.24198 25.7557C3.24198 29.7182 6.48396 32.9601 10.4464 32.9601C11.3469 32.9601 12.2475 33.3204 12.9679 34.0408C14.4088 35.3016 16.2099 36.022 18.011 36.022C19.8121 36.022 21.7933 35.3016 23.0541 33.8607C23.7745 33.1402 24.6751 32.78 25.5756 32.78C29.538 32.78 32.78 29.538 32.78 25.5756C32.78 24.6751 33.1402 23.7745 33.6806 23.0541C36.7424 20.3524 36.7424 15.6696 33.8607 12.9679Z",
    fill: "#55A55E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1724 14.77L17.1105 19.2728L16.2099 18.3722C15.4895 17.6518 14.4088 17.6518 13.6884 18.3722C12.968 19.0927 12.968 20.1733 13.6884 20.8938L16.2099 23.4153C16.5702 23.7755 16.9304 23.9557 17.4707 23.9557H17.6508C18.1912 23.9557 18.7315 23.5954 18.9116 23.2352L23.2342 16.7513C23.7746 15.8507 23.5945 14.77 22.6939 14.2297C21.7934 13.6894 20.7127 13.8695 20.1724 14.77Z",
    fill: "#EFECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterSuccess);
export default __webpack_public_path__ + "static/media/toaster-success.cb6f5690038b2f9702f97b4865e06f61.svg";
export { ForwardRef as ReactComponent };